export const authConfig = {
    externalURL: "https://admin.gotravelandtours.com/#/dasboard/admin/products",
    userParam: 'user',
    passParam: 'pass'
}